import {
  AUTHENTICATING_OUTREACH_REQUEST, AUTHENTICATING_OUTREACH_SUCCEDDED, AUTHENTICATING_OUTREACH_FAILED,
  UPDATING_OUTREACH_REQUEST, UPDATING_OUTREACH_SUCCEDDED, UPDATING_OUTREACH_FAILED, 
} from '../../actions/actionTypes.jsx';

const initialState = {
  changes: {
    saving: false,
    error: null
  },
  authentication: {
    authenticating: false,
    error: null
  }
};

function outreachReducer(state = initialState, action) {
  switch (action.type) {
    case AUTHENTICATING_OUTREACH_REQUEST:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: true,
          error: null
        }
      })

    case AUTHENTICATING_OUTREACH_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: null
        }
      })

    case AUTHENTICATING_OUTREACH_FAILED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: action.payload
        }
      }) 
    
    case UPDATING_OUTREACH_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: true,
          error: null
        }
      })
    case UPDATING_OUTREACH_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: null
        }
      })
    case UPDATING_OUTREACH_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: action.payload
        }
      })

    default:
      return state; 
  }
}

export { outreachReducer };